<template>
  <div class="container">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多数据"
        @load="onLoad"
        :immediate-check="false"
        class="mylist"
      >
        <div class="newsitem" v-for="(item,index) of dataList" :key="index" @click="goDetails(item.noteId)">
          <!-- <div class="newsinfo">
            <span class="newstype">{{item.typeName}}</span>
            <span class="time">{{item.noteTime}}</span>
          </div> -->
          <h2 class="newstitle">{{item.title}}</h2>
          <!-- <p class="newscon">他认为解绑举措应该在20世纪90年代展开，那时能源价格低廉，投资要求微不足道，供应充足他认为解绑举措应该在20世纪90年代展开，那时能源价格低廉，投资要求微不足道，供应充足</p> -->
          <div class="newsinfo">
            <span class="time">{{item.noteTime}}</span>
            <span class="read" v-if="item.isRead==1">已读</span>
            <span class="unread" v-else>未读</span>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  data(){
    return{
      loading: false,
      finished: false,
      isLoading: false,
      pageNum: 1,  //显示的是哪一页
      pageSize: 10, //每一页显示的数据条数
      total: 0, //记录总数
      isEmpty: false,
      dataList:[],
    }
  },
  methods:{
    goDetails(id){
      this.$router.push({path:"/newsdetails",query:{id}})
    },
    // 下拉刷新
    onRefresh() {
      this.pageNum = 1
      this.finished = false;
      this.loading = true;
      this.isLoading = true
      this.getData()
    },
    onLoad() {
      this.pageNum++
      this.getData()
    },
    getData(){
      this.axios.get("/note/tzList/",{params:{type:2,pageNum:this.pageNum,pageSize:this.pageSize}})
      .then(res=>{
        if(res.code == 200) {
          this.finished = false;
          // 加载状态结束
          if (this.isLoading) {
            this.dataList = [];
            this.isLoading = false;
          }
          this.loading = false;
          // console.log(res.data)
          this.dataList = this.dataList.concat(res.rows);
          // console.log(this.dataList)
          this.total = res.total
          if (this.dataList.length >= this.total) {
            this.finished = true;
          }
        }
      })
    },
  },
  created(){
    this.getData()
  }
}
</script>

<style src="@/assets/css/css.css" scoped></style>
<style scoped>

</style>